import React from "react";

import PageStructure from "../components/ui/PageStructure";
import { COMPLETED_GOAL } from "../utils/constants";

// comoponent for completed goals page
const Completed: React.FC = () => {
  return <PageStructure title="completed goals" filter={COMPLETED_GOAL} />;
};

export default Completed;
